module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/tokens.cd2d0b54.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/tokens.png
// module id = 3078
// module chunks = 11